<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>分站管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加分站</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加分站</span>
      </div>
      <div class="xcx-content">
        <el-form ref="form_data" :model="form_data" :rules="rules" label-width="160px" style="width: 80%">
          <el-form-item label="用户名：" prop="title">
            <el-input v-model="form_data.title" placeholder="请输入站点标题"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="keywords">
            <el-input v-model="form_data.keywords" placeholder="请输入分享关键词"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="description">
            <el-input v-model="form_data.description" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="description">
            <el-input v-model="form_data.description" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="域名前缀：" prop="description">
            <el-input v-model="form_data.description" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="域名：" prop="description">
            <el-input v-model="form_data.description" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="description">
            <el-input v-model="form_data.description" placeholder="请输入分享描述"></el-input>
          </el-form-item>

          <el-form-item label="微信验证文件：" prop="picture" class="txt_left kind_img">
            <el-upload class="updata_img" :action="upload_img_url" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
            <div style="font-size: 12px; color: #606266">
              为1:1比例图片 （不小于140 x 140px）
            </div>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      form_data: {
        title: "",
        keywords: "",
        description: "",
        wxqrcode: "",
        kfqrcode: "",
        picture: [],
        qrcode: [],
        id: 0,
      },
      upload_img_url: this.adminApi.upload_url,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      id: "",
      rules: {
        title: [{ required: true, message: "请输入站点标题", trigger: "blur" }],
        keywords: [
          { required: true, message: "请输入分享关键词", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入分享描述", trigger: "blur" },
        ],
        picture: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
            type: "array",
            min: 1,
          },
        ],
        qrcode: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
            type: "array",
            min: 1,
          },
        ],
      },
    };
  },
  mounted() {
    var that = this;
    that.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/Config/site").then((res) => {
        if (res) {
          if (res.data) {
            that.form_data = res.data;
            that.form_data.picture = [
              {
                name: "img",
                url: res.data.wxqrcode,
              },
            ];
            that.form_data.qrcode = [
              {
                name: "img",
                url: res.data.kfqrcode,
              },
            ];
          }
          that.loading = false;
        }
      });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        if (that.form_data.picture.length == 0) {
          return that.$message.warning("请上传图片!");
        }
        formData = that.form_data;
        var url = "/Config/siteupdate";
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/Config/site");
        });
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style>
.kind_img .updata_img .el-upload-list__item-actions,
.kind_img .updata_img .el-upload-list__item-thumbnail,
.kind_img .updata_img .el-upload-list__item.is-success,
.kind_img .updata_img .el-upload-list__item.is-undefined,
.kind_img .updata_img .el-upload-list__item.is-uploading {
  width: 300px;
  height: 40px;
}
.kind_img .updata_img .el-upload.el-upload--picture-card {
  width: 300px;
  height: 40px;
}
</style>